/*
Hides global app loader which is declared in host package and is shared across applicatons that belongs under host app.
- Each application has to hide loader on its own when its core things are loaded and app is ready to be shown to user, by calling below function (most preferably on App.vue, should be called only once in scope of one application)
- Don't treat this loader as a loader-on-demand which can be shown again during any application workflow. it should be only hidden once and never shown again.
- loader itself is implemented in vue\packages\host\public\index.html
*/
export function hideAppLoader(): void {
  document.getElementById('appLoader')?.remove();
  document.getElementById('appLoaderStyles')?.remove();
}

export const attachHTMLtoElementShadow = (
  element: Element | HTMLElement| null,
  html: string, mode: 'closed' | 'open' = 'open'
): void => {
  if (element?.attachShadow && element.shadowRoot === null) {
    const shadowR00t = element.attachShadow({ mode });
    if (shadowR00t) {
      shadowR00t.innerHTML = html;
    }
  }
};